/**
 * Extracts the error message from an HTTP error response.
 *
 * Supports multiple backend response formats:
 * - Old API (Google Cloud Endpoints): error.error.error.message
 * - New FINRA API (Spring Boot):      error.error.message
 * - Fallback (Angular HttpErrorResponse): error.message
 **/
export function extractErrorMessage(error: any): string {
  return error?.error?.error?.message ?? error?.error?.message ?? error?.message ?? 'Unknown error';
}

